import React from 'react';

export const IconAddToList = (
  <svg aria-label="Icon Add to List" width="1em" height="1em" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="nonzero" d="M12 2.843A9.155 9.155 0 0 0 2.843 12 9.155 9.155 0 0 0 12 21.157 9.155 9.155 0 0 0 21.157 12 9.155 9.155 0 0 0 12 2.843zm5.317 10.19c0 .245-.2.444-.443.444h-3.397v3.397c0 .244-.2.443-.443.443h-2.068a.444.444 0 0 1-.443-.443v-3.397H7.126a.444.444 0 0 1-.443-.443v-2.068c0-.244.2-.443.443-.443h3.397V7.126c0-.244.2-.443.443-.443h2.068c.244 0 .443.2.443.443v3.397h3.397c.244 0 .443.2.443.443v2.068z" />
  </svg>
);
